/**
 * ISSUE-1188. The player page's Stats tab (Scores UX spec v1.0 section 9,
 * ux-spec-v1.md line 563, and .agents/docs/design/platforms/web.md): one card
 * per stat group, its facts in a 4-column grid (8 from 640px), gap 8 by 16.
 * Each fact is the server's value over its label, and the league rank under a
 * ranked stat. This component formats and ranks nothing.
 */
import type { ReactNode } from "react";

import { GameSectionCard } from "../gameDetail/GameSectionCard";
import type { typePlayerStatGroup } from "./playerSeasonView";

export const PlayerStatsPanel = (props: {
  groups: readonly typePlayerStatGroup[];
}): ReactNode => (
  <div data-testid="player-stats" className="flex flex-col gap-4">
    {props.groups.map((group) => (
      <GameSectionCard
        key={group.groupKey}
        testId="player-stats-group"
        title={group.label}
        dataAttributes={{ "data-group-key": group.groupKey }}
      >
        <div
          data-testid="player-stats-grid"
          className="grid grid-cols-4 gap-x-2 gap-y-4 sm:grid-cols-8"
        >
          {group.stats.map((fact) => (
            <div
              key={fact.statKey}
              data-testid={`player-stat-${group.groupKey}-${fact.statKey}`}
              className="flex min-w-0 flex-col"
            >
              <span className="text-body-strong text-ink tabular-nums">
                {fact.displayValue}
              </span>
              <span className="text-small text-ink-secondary">
                {fact.label}
              </span>
              {fact.rankLabel !== null ? (
                <span
                  data-testid="player-stat-rank"
                  className="text-small text-ink-tertiary tabular-nums"
                >
                  {fact.rankLabel}
                </span>
              ) : null}
            </div>
          ))}
        </div>
      </GameSectionCard>
    ))}
  </div>
);
